import { render } from "./First.vue?vue&type=template&id=16a7155b&scoped=true"
import script from "./First.vue?vue&type=script&lang=js"
export * from "./First.vue?vue&type=script&lang=js"

import "./First.vue?vue&type=style&index=0&id=16a7155b&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a7155b"]])

export default __exports__